var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","layout":_vm.lay,"total":_vm.count,"current-page":_vm.value,"page-size":_vm.limit},on:{"current-change":_vm.on.page}})
}
var staticRenderFns = []

export { render, staticRenderFns }